import { Group } from './Columns'

interface Props {
  groupIds: number[]
  groupList: Group[]
}

const GroupsCell = ({ groupIds = [], groupList = [] }: Props) => {
  return (
    <div>
      {(groupList && groupIds && groupList.filter((group: Group) => groupIds.includes(group.id))
        .map((group: Group) => group.title).join(', '))}
    </div>
  )
}

export default GroupsCell
